"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
  [703], {
    6519: (e, t, a) => {
      a.r(t);
      var n = a(7401),
        c = a(4831),
        i = a(693),
        r = a(5),
        s = a(9394),
        l = a(1438),
        o = a(8692),
        m = a(4412);
      const u = (e, t) => {
        switch (t.type) {
          case "LOADING":
            return {
              ...e, isLoading: t.value || !0
            };
          case "UPDATE_BASKET":
            return {
              ...e, isLoading: !1, ...t.data
            };
          default:
            return e
        }
      };

      function d() {
        const [e, t] = (0, n.useReducer)(u, {
          isLoading: !1,
          itemCount: 0,
          items: [],
          totalPrice: 0,
          originalTotalPrice: 0
        }), {
          isLoading: a,
          itemCount: c,
          items: i,
          totalPrice: r,
          originalTotalPrice: m
        } = e, d = async ({
          line: e,
          quantity: a
        }) => {
          t({
            type: "LOADING"
          }), await l.J8({
            line: e,
            quantity: a
          })
        };
        return (0, n.useEffect)((() => {
          (0, s.$e)((() => l.hJ())), o.N.on("propify:cart:update", (({
            detail: e
          }) => {
            t({
              type: "UPDATE_BASKET",
              data: e
            })
          }))
        }), []), n.createElement("div", {
          className: "c-mini-basket"
        }, n.createElement("header", {
          className: "c-mini-basket__header"
        }, n.createElement("h2", {
          className: "text-epsilon tracking-1"
        }, "Bag", " ", i.length > 0 ? `(${i.reduce(((e, t) => e + t.quantity), 0).toString().padStart(2, "0")})` : "")), n.createElement("ul", {
          className: "c-mini-basket__items"
        }, 0 === c && n.createElement("li", {
          className: "text-centi text-upper font-tertiary u-mt-30"
        }, "There are no items in bag."), i.map((e => "39990406643802" == e.variantId ? null : n.createElement(p, {
          key: e.key,
          item: e,
          onItemUpdate: d
        })))), n.createElement("footer", {
          className: "c-mini-basket__footer text-upper tracking-4"
        }, c > 0 && n.createElement(n.Fragment, null, n.createElement("div", {
          className: "font-tertiary text-centi text-light"
        }, n.createElement("span", null, "Subtotal"), n.createElement(y, {
          isLoading: a,
          price: r,
          originalPrice: m
        })), n.createElement("a", {
          className: "c-button c-button--primary c-button--full",
          href: window.routes.cart_url
        }, n.createElement("span", null, "View Basket and Checkout"))), n.createElement("button", {
          className: "c-button c-button--secondary text-centi",
          type: "button",
          onClick: e => {
            (e.currentTarget == e.target || e.currentTarget.contains(e.target)) && MiniBasket.hide()
          }
        }, n.createElement("span", null, "Continue Shopping"))), n.createElement(E, {
          items: i
        }))
      }

      function p({
        item: e,
        onItemUpdate: t
      }) {
        const [a, c] = (0, n.useState)(!1), i = (0, n.useRef)(e), {
          image: r,
          title: s,
          url: l,
          finalLinePrice: o,
          originalLinePrice: m,
          properties: u,
          options: d
        } = e;
        return n.createElement("li", {
          className: "c-mini-basket__item text-centi text-upper font-tertiary tracking-4"
        }, n.createElement("img", {
          "data-child": "image",
          className: "o-img o-img--contain js-lazyload",
          width: "59",
          height: "66",
          "data-src": r,
          alt: ""
        }), n.createElement("div", {
          "data-child": "title",
          className: "text-light text-upper"
        }, n.createElement("a", {
          href: fixLangUrl(l)
        }, s), n.createElement("p", {
          className: "text-micro"
        }, d?.map((e => "title" !== e.name.toLowerCase() && n.createElement("span", {
          key: e.name,
          className: "u-block"
        }, e.name, ": ", e.value))), u?.map((e => e[1] && n.createElement("span", {
          key: e[0],
          className: "u-block"
        }, e.join(": ")))))), n.createElement("button", {
          "data-child": "action",
          type: "button",
          onClick: async () => {
            i.current = {
              ...e
            }, i.current.quantity = 0, c(!0), await t(i.current)
          },
          "aria-label": "Remove",
          title: "Remove"
        }, n.createElement("svg", {
          className: "c-ico"
        }, n.createElement("use", {
          xlinkHref: "#icon-close"
        }))), n.createElement("div", {
          "data-child": "quantity",
          className: "c-quantity"
        }, n.createElement(h, {
          onQuantityChange: async a => {
            i.current = {
              ...e
            }, i.current.quantity = a, i.current.quantity !== e.quantity && (c(!0), await t(i.current), c(!1))
          },
          quantity: e.quantity
        })), n.createElement("div", {
          "data-child": "price"
        }, n.createElement(y, {
          isLoading: a,
          price: o,
          originalPrice: m
        })))
      }

      var qtyChangeTimeout;
      function h({
        onQuantityChange: e,
        quantity: t
      }) {
        const [a, c] = (0, n.useState)(t);
        return (0, n.useEffect)((() => {
          c(t)
        }), [t]), n.createElement(n.Fragment, null, n.createElement("button", {
          type: "button",
          onClick: (ev) => {
            if (t > -1) {
              t--;
              ev.target.closest('.c-quantity').querySelector('input').value = t;
              clearTimeout(qtyChangeTimeout);  
              qtyChangeTimeout = setTimeout(function(){
                c(t);
                e(t)
              }, 300);
            } 
          }
        }, n.createElement("svg", {
          className: "c-ico"
        }, n.createElement("use", {
          xlinkHref: "#icon-minus-s"
        }))), n.createElement("input", {
          type: "text",
          value: a || "",
          inputMode: "numeric",
          pattern: "[0-9]*",
          onChange: t => {
            const a = +t.target.value;
            isNaN(a) || (c(a), a > 0 && e(a))
          }
        }), n.createElement("button", {
          type: "button",
          onClick: (ev) => {
            t++;
            ev.target.closest('.c-quantity').querySelector('input').value = t;
            clearTimeout(qtyChangeTimeout);
            qtyChangeTimeout = setTimeout(function(){
              c(t);
              e(t)
            }, 300);
          }
        }, n.createElement("svg", {
          className: "c-ico"
        }, n.createElement("use", {
          xlinkHref: "#icon-plus-s"
        }))))
      }

      function y({
        isLoading: e,
        price: t,
        originalPrice: a
      }) {
        return n.createElement("span", {
          className: "c-price"
        }, e ? n.createElement(g, null) : a && a > t ? n.createElement("span", {
          className: "c-price__sale"
        }, n.createElement("s", {
          className: "price-item price-item--regular"
        }, l.lb({
          cents: a
        })), l.lb({
          cents: t
        })) : n.createElement("span", {
          className: "c-price__regular"
        }, l.lb({
          cents: t
        })))
      }

      function g() {
        return n.createElement("div", {
          className: "c-mini-basket__loader"
        }, n.createElement("svg", {
          "aria-hidden": "true",
          focusable: "false",
          role: "presentation",
          className: "spinner",
          viewBox: "0 0 66 66",
          width: "1em",
          height: "1em"
        }, n.createElement("circle", {
          className: "path",
          fill: "none",
          strokeWidth: "6",
          cx: "33",
          cy: "33",
          r: "30"
        })))
      }

      function E({
        items: e
      }) {
        const t = [...new Set(e.map((e => e.productId)))],
          {
            data: a,
            isError: c,
            isLoading: i
          } = function (e) {
            const t = (0, n.useMemo)((() => {
              const t = new URL("/json/preferences/also-bought.json", "https://www.codeblackbelt.com");
              t.searchParams.set("shop", window.Shopify.shop.replace("localhost:3000", "demel-wien.myshopify.com")), t.searchParams.set("activeCurrencyCode", window.Shopify.currency.active), t.searchParams.set("marketCountry", window.Shopify.country), t.searchParams.set("marketCurrency", window.Shopify.currency.active);
              for (const a of e) t.searchParams.append("productIdList[]", a + "");
              return t.searchParams.set("path", window.routes.cart_url), t
            }), [e.length]),
              {
                data: a,
                error: c
              } = (0, r.Z)(e.length > 0 && "miniBasketRecommendations", (() => fetch(`${t}`).then((e => e.json()))), {
                onError() {
                  sessionStorage.removeItem("miniBasketRecommendations")
                },
                onSuccess(e) {
                  sessionStorage.setItem("miniBasketRecommendations", JSON.stringify(e))
                }
              });
            return {
              data: a,
              isLoading: !c && !a,
              isError: c
            }
          }(t),
          s = a?.preferences?.[0].products;
        return i || c ? n.createElement("div", null) : s?.length ? n.createElement("div", {
          className: "c-mini-basket__recommended"
        }, n.createElement("p", {
          className: "font-primary text-epsilon tracking-1 color-secondary"
        }, "You May Also Like"), n.createElement("ul", null, s.filter((e => !t.includes(e.id))).slice(0, 2).map((e => n.createElement("li", {
          key: e.id,
          className: "c-mini-basket__item text-centi font-tertiary tracking-4"
        }, n.createElement("img", {
          "data-child": "image",
          className: "o-img o-img--contain js-lazyload",
          width: "140",
          height: "140",
          "data-src": e.variants[0].image_url + "&width=140&height=140",
          loading: "lazy",
          alt: ""
        }), n.createElement("div", {
          "data-child": "title",
          className: "text-upper"
        }, n.createElement("a", {
          href: `${window.routes.products_url}/${e.url}`
        }, e.name)), n.createElement("div", {
          "data-child": "quantity"
        }, n.createElement("button", {
          type: "button",
          className: "c-button c-button--secondary",
          onClick: () => {
            l.Xq({
              items: [{
                id: e.variant_id,
                quantity: 1
              }]
            })
          }
        }, n.createElement("span", null, "Add to bag"))), n.createElement("div", {
          "data-child": "price"
        }, n.createElement(y, {
          price: 100 * e.variants[0].shop_currency_price
        }))))))) : n.createElement("div", null)
      }
      const f = sessionStorage.getItem("miniBasketRecommendations");
      f && (0, i.JG)("miniBasketRecommendations", JSON.parse(f), !1), (0, c.s)((0, m.U2)("#app-minibasket")).render(n.createElement(n.StrictMode, null, n.createElement(d, null)))
    },
    8692: (e, t, a) => {
      a.d(t, {
        N: () => c
      });
      class n {
        constructor(e = "") {
          this.eventTarget = void 0, this.eventTarget = document.appendChild(document.createComment(e))
        }
        on(e, t) {
          this.eventTarget.addEventListener(e, t)
        }
        once(e, t) {
          this.eventTarget.addEventListener(e, t, {
            once: !0
          })
        }
        off(e, t) {
          this.eventTarget.removeEventListener(e, t)
        }
        emit(e, t) {
          return this.eventTarget.dispatchEvent(new CustomEvent(e, {
            detail: t
          }))
        }
      }
      const c = new n("Demel - Event Bus")
    },
    1438: (e, t, a) => {
      a.d(t, {
        J8: () => l,
        Xq: () => s,
        hJ: () => r,
        lb: () => i
      });
      var n = a(4412),
        c = a(8692);

      function i({
        cents: e
      }) {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: window.Shopify.currency.active
        }).format(e / 100)
      }
      async function r() {
        const e = await fetch("/cart?view=ajax").then((e => e.json()));
        c.N.emit("propify:cart:update", e);
        const t = (0, n.go)(".js-cart-count");
        for (const a of t) a.setAttribute("data-count", `${e.itemCount || ""}`);
        return e
      }
      async function s(e) {
        let t;
        const a = {};
        return e instanceof FormData ? t = e : (t = JSON.stringify(e), a["Content-Type"] = "application/json"), await fetch("/cart/add.js", {
          method: "POST",
          headers: a,
          body: t
        }), r()
      }
      async function l(e) {
        console.log('change!', e);
        return await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(e)
        }), r()
      }
    }
  }
]);